<template lang="pug">
  div
    top-nav(headerColor="white")
    .placeholder(v-if="loading")
    transition(name='fade')
      .content.info(v-if="!loading")
        .grid-noBottom.margin-top-12
          .col-4_xs-12.titles
            router-link(:to="{ name: category}")
              h2.h-l
                | {{ category }}
            router-link(:to="{ path: '/' + parent }" v-if="subpage")
              h3.h-sm.parent(:style="textColor")
                | {{ parentTitle.toLowerCase() }}
            h1.h-xl(:style="textColor")
              | {{ loadedData[key].title }}
            ul
              li(v-for="child in children")
                router-link(:to="{path: '/' + child.uri}")
                  h3.h-sm
                    | {{ child.content.title.toLowerCase() }}
            h4.h-sm.share(@click="share=!share")
              | share
              transition(name='fade')
                social(v-if="share" :meta="shareInfo")
          .col-8_xs-12.rc(v-if="url")
            .hero
              img.cover(:src="url" :alt="parentTitle")
            .captions-hero(v-if="heroCaptions")
              p(v-html="heroCaptions")
          .col-5_xs-12.rc(data-push-left="off-4_xs-0" v-if="url")
            .copy.wysiwyg(v-html="text")
            swiper.gallery(:options="swiperOption" ref="info-gallery" v-if="gallery")
              swiper-slide(v-for="image in gallery" :key="image.title")
                .slide
                  img.cover(:src="image.url")
              .swiper-button-prev(slot="button-prev")
              .swiper-button-next(slot="button-next")
          .col-5_xs-12.rc(v-else)
            .copy.wysiwyg.no-hero(v-html="text")
            swiper.gallery(:options="swiperOption" ref="info-gallery" v-if="gallery")
              swiper-slide(v-for="image in gallery" :key="image.title")
                .slide
                  img.cover(:src="image.url")
              .swiper-button-prev(slot="button-prev")
              .swiper-button-next(slot="button-next")
          .col-3_xs-12.rc
            .box.wysiwyg(v-html="box")
    bottom-nav(footerColor="white")
</template>

<script>
/* eslint-disable */
import DataMixin from '@/mixins/DataMixin'
import ComponentMixin from '@/mixins/ComponentMixin'
import VueScript2 from 'vue-script2'

export default {
  name: 'info-page',
  mixins: [DataMixin, ComponentMixin],

  data () {
    return {
      share: false,
      subpage: ('subid' in this.$route.params),
      swiperOption: {
        notNextTick: true,
        autoplay: false,
        direction: 'horizontal',
        prevButton: '.swiper-button-prev',
        nextButton: '.swiper-button-next',
        mousewheelControl: false,
        observeParents: true,
        debugger: false
      }
    }
  },

  created () {
    this.requestData(this.key, 'info')
  },

  computed: {
    key: function () {
      return this.$route.path.substring(1)
    },

    parent: function () {
      return this.loadedData[this.key].parent
    },

    parentTitle: function () {
      if (this.loadedData[this.key].parent_title) {
        return this.loadedData[this.key].parent_title
      } else {
        return ''
      }
    },

    content: function () {
      return this.loadedData[this.key].content
    },

    files: function () {
      return this.loadedData[this.key].files
    },

    hero: function () {
      const name = this.content.main_image
      return this.files.find(item => item.filename === name)
    },

    isVisible: function () {
      return !this.loading ? this.loadedData[this.key].isVisible : true
    },

    gallery: function () {
      const names = this.content.gallery
      let images = []

      if (names.length > 0) {
        const nameArray = names.split(',')
        for (var i = 0; i < nameArray.length; i++) {
          let n = nameArray[i]
          images.push(this.files.find(item => item.filename === n))
        }
        return images
      } else {
        return false
      }
    },

    url: function () {
      if (this.hero) {
        return this.hero.url
      }
    },

    heroMeta: function () {
      if (!(Object.prototype.toString.call(this.hero.meta) === '[object Array]')) {
        return this.hero.meta
      } else {
        return false
      }
    },

    heroCaption: function () {
      if (this.heroMeta) {
        return this.heroMeta.caption.length > 0 ? this.heroMeta.caption : false
      }
    },

    heroCredit: function () {
      if (this.heroMeta) {
        return this.heroMeta.credit.length > 0 ? this.heroMeta.credit : false
      }
    },

    heroCaptions: function () {
      const cap = this.heroCaption
      const cred = this.heroCredit
      if (cap && cred) {
        return cap + '. ' + cred + '.'
      } else if (cap) {
        return cap + '.'
      } else if (cred) {
        return cred + '.'
      } else {
        return false
      }
    },

    text: function () {
      return this.content.text
    },

    box: function () {
      return this.content.box
    },

    category: function () {
      return this.key.split('/')[0]
    },

    children: function () {
      return this.loadedData[this.key].children
    },

    textColor: function () {
      return 'color: ' + this.colors[this.category]
    },

    shareInfo: function () {
      const data = {
        url: this.loadedData[this.key].url,
        title: this.title,
        description: this.text,
        image: this.hero.url
      }
      return data
    }
  },

  updated: function () {
    VueScript2.load('https://assets.calendly.com/assets/external/widget.js').then(function () {
      if (Calendly.initInlineWidgets) {
        Calendly.initInlineWidgets()
      }
    })
  },

  watch: {
    $route: function (to) {
      this.subpage = ('subid' in to.params)
      this.requestData(this.key, 'info')
    },

    loading: function () {
      if (!this.isVisible && !this.loading) {
        this.$router.push('/404')
      }
    }
  }
}
</script>

<style lang="sass">
  @import '../styles/_mixins'
  @import '../styles/_variables'
  .info
    .margin-top-12
      @include respond-to(xs)
        margin-top: 2rem
    .captions-hero
      margin-top: 1.2rem
      p
        color: #636466
    .titles
      h1
        padding-top: 0
      ul
        margin-top: 4rem
        @include respond-to(xs)
          margin-top: 0rem
      h3
        margin-bottom: 0.5rem
      .share
        margin-top: 1rem
        cursor: pointer
        color: #939598
    .copy, .box
      width: 100%
      margin-top: 6rem
      @include respond-to(xs)
        margin-top: 0rem
    .box
      width: 92%
      padding-left: 8%
      @include respond-to(xs)
        padding-left: 0
    .gallery
      width: 60.5vW
      margin-left: 0
      height: 34.5vW
      margin-top: 6rem
      @include respond-to(xs)
        width: 100%
      .swiper-slide
        display: flex
        justify-content: center
      .slide
        height: 34.5vW
        width: 88%
        padding: 0
        display: flex
        justify-content: center
        @include respond-to(xs)
          width: 100%
        img
          width: auto !important
          max-width: 100% !important
          height: 34.5vW !important
          padding: 0 !important
          @include respond-to(xs)
            width: 100% !important
            height: 50vw !important
      .swiper-button-prev
        left: 0px
        background-image: url('/static/icons/left_arrow.svg')
      .swiper-button-next
        right: 0
        background-image: url('/static/icons/right_arrow.svg')
      .swiper-button-next, .swiper-button-prev
        @include respond-to(xs)
          display: none
</style>



// WEBPACK FOOTER //
// InfoPage.vue?2a17093d